import { Link, useMatchRoute } from '@tanstack/react-router';
import { Text } from '@/components/ui/Text';
import { CRM_NAV_GROUPS, type CrmNavItem } from '@/lib/crm/crm-nav';
import { useCrmAccess } from '@/lib/crm/use-crm-access';

/**
 * The CRM tool's own navigation (ENT-565), built from `CRM_NAV`. Each tab is shown only when the
 * caller can open its page; a group with no visible tab is not drawn.
 */
export function CrmSidebarNav({ linkBase, linkActive }: { linkBase: string; linkActive: string }) {
  const { visibleNav } = useCrmAccess();
  const matchRoute = useMatchRoute();
  const isActive = (item: CrmNavItem) =>
    !!matchRoute({ to: item.to, fuzzy: true }) &&
    !(item.excludes ?? []).some((path) => matchRoute({ to: path, fuzzy: true }));

  return (
    <nav className="flex-1 py-3 overflow-y-auto" aria-label="CRM">
      {CRM_NAV_GROUPS.map((group) => {
        const items = visibleNav.filter((item) => item.group === group);
        if (items.length === 0) return null;
        return (
          <div key={group} className="px-2.5 space-y-0.5 mb-4">
            <Text variant="label-sm" as="div" className="px-4 mb-2 text-sidebar-muted">
              {group}
            </Text>
            {items.map((item) => {
              const Icon = item.icon;
              return (
                <Link key={item.id} to={item.to} className={isActive(item) ? linkActive : linkBase}>
                  <Icon size={15} className="shrink-0" />
                  {item.label}
                </Link>
              );
            })}
          </div>
        );
      })}
    </nav>
  );
}
